import { useStorage } from '@vueuse/core';
import { watchEffect } from 'vue';

/**
 * 产品约定：默认浅色（白），不跟随系统 prefers-color-scheme，也不按时段自动切换。
 * localStorage 仅在用户主动 toggle 时写入 dark。
 */
export const theme = useStorage('theme', 'light');

export function toggleTheme() {
  theme.value = theme.value === 'light' ? 'dark' : 'light';
}

watchEffect(() => {
  const htmlEl = document.documentElement;
  const isDark = theme.value === 'dark';
  htmlEl.classList.toggle('dark', isDark);
  // 锁定浏览器表单控件 / 滚动条等，避免跟 OS 深色模式跑偏
  htmlEl.style.colorScheme = isDark ? 'dark' : 'light';
});
